export const nodeSpaceAllocationColors = [
    "var(--codex-color-primary)",
    "#f9fa93",
    "#ccc",
]